function a(r) {
  if (Array.isArray(r)) return r;
}
export {
  a as default
};
